<template>
  <detail-item
    icon="mdi-email"
    name="Email Addresses"
    :name-spacing="nameSpacing"
  >
    <q-item-label v-if="emailList.length < 1" class="text-grey-7">
      No email addresses to display
    </q-item-label>

    <div
      v-for="(email, key) in emailList"
      :key="key"
      class="q-pb-md"
    >
      <q-item-label class="text-bold">
        {{ email.field_name }} Email
      </q-item-label>

      <email-address
        ref="emailInput"
        v-model="email.email_address"
        outlined
        dense
        clearable
        hide-bottom-space
        autocomplete="none"
        :error="!!emailHasError(key)"
        :error-message="emailHasError(key) ? emailHasError(key)[0] : null"
        @clear="removeEmail(key)"
      >
        <template #append>
          <q-btn
            icon="mdi-dots-vertical"
            class="cursor-pointer"
            round
            dense
            flat
            @click.stop
          >
            <q-tooltip>Options</q-tooltip>
            <q-popup-proxy>
              <q-card
                class="q-pa-md"
                style="width: 300px;"
              >
                <q-item-label
                  header
                  class="q-pa-none text-bold"
                >
                  Email Type
                </q-item-label>

                <q-option-group
                  :model-value="email.type"
                  type="radio"
                  :options="emailTypeOptionsWithDisabled"
                  class="q-mb-sm"
                  @update:model-value="(value) => onTypeSelect(email, value)"
                />

                <q-input
                  v-if="email.type === 'EXTRA'"
                  v-model="email.field_name"
                  outlined
                  class="required-astrx-container"
                  label="Email Display Name"
                  :error="!email.field_name"
                />

                <q-btn
                  label="Remove Email"
                  flat
                  dense
                  no-caps
                  color="red"
                  @click="removeEmail(key)"
                />
              </q-card>
            </q-popup-proxy>
          </q-btn>
        </template>
      </email-address>
    </div>

    <q-btn
      color="teal"
      icon="mdi-plus"
      label="Add Email"
      size="12px"
      class="q-mt-sm"
    >
      <q-menu>
        <q-card style="min-width: 150px;">
          <q-list dense>
            <q-item-label
              header
              class="text-bold q-py-sm"
            >
              Select Email Type:
            </q-item-label>
            <q-item
              v-for="(type, key) in emailTypeOptions"
              :key="key"
              v-close-popup
              clickable
              @click="addEmail(type.value)"
            >
              <q-item-section>{{ type.label }}</q-item-section>
            </q-item>
          </q-list>
        </q-card>
      </q-menu>
    </q-btn>
  </detail-item>
</template>

<script>
import PhoneAddressEmailMixin from 'components/partials/PhoneAddressEmail'

export default {
  mixins: [PhoneAddressEmailMixin],
  props: {
    emailList: {
      type: Array,
      required: true
    },
    mode: {
      type: String,
      required: true
    },
    client: {
      type: Object,
      required: true
    },
    nameSpacing: {
      type: Number
    },
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    usedOptions () {
      return this.emailList.map(item => item.type).filter(item => item !== 'EXTRA')
    },
    emailTypeOptions () {
      return this.emailTypes.filter(item => !this.usedOptions.includes(item.value))
    },
    emailTypeOptionsWithDisabled () {
      return this.emailTypes
        .filter(item => item)
        .map(item => {
          item.disable = this.usedOptions.includes(item.value)
          return item
        })
    }
  },
  methods: {
    emailHasError (key) {
      for (const index in this.errors) {
        if (['emails.' + key, 'emails.' + key + '.email_address'].includes(index)) {
          return this.errors[index]
        }
      }
      return null
    },
    getFieldType (type) {
      const field = this.emailTypes.find(item => item.value === type)
      return {
        type: field.value,
        field_name: field.label
      }
    },
    addEmail (type) {
      const nextEmailType = this.getFieldType(type)
      this.emailList.push(this.getEmailPayload(true, {
        type: nextEmailType.type,
        field_name: nextEmailType.field_name
      }))

      this.timed(() => {
        this.$refs.emailInput[this.$refs.emailInput.length - 1].focus()
      }, 100)
    },
    removeEmail (key) {
      this.emailList.splice(key, 1)
    },
    onTypeSelect (email, value) {
      const item = this.emailTypeOptions.find(item => item.value === value)
      email.type = item.value
      email.field_name = item.label
    }
  }
}
</script>
